﻿import { analyticsPushFunc, openWhatsAppShare } from "../../../../widgetsUtils";
import { ArticleHeader1280AiSummary, SummaryDataItem } from "./articleHeader1280AiSummary";
import {
    WCM_COMMENTS_EVENT,
    WCM_READ_ALOUD_REQUEST_EVENT,
    WCM_READ_ALOUD_STATE_EVENT,
    dispatchBepoRecommendationsOpen,
    shouldRenderArticleSummary,
    formatCommentCountMagazine,
    formatCommentCountRegular,
    formatReadAloudDuration,
    getActionBarLabels,
    resolveReadAloudData,
    resolveReadAloudMediaImageUrl,
    ReadAloudRequestDetail,
    ReadAloudStateDetail,
} from "./actionBarShared";
import { BepoFloatingPlayerController } from "../../../radioWidgets/bepoFloatingPlayer/bepoFloatingPlayerController";
import { YplusPremiumGated } from "../../../../../global/paywall/yplusPremiumGated";

declare var window: Window & {
    wcmAudioPlayer: { stop: () => void; togglePlayPause?: () => void }
    handleCommentsPopupVisability?: () => void
}

let activeMobileReadAloudPlayerHost: ArticleMobileActionBarComponent | null = null

interface ArticleMobileActionBarProps {
    url: string
    title?: string
    lang?: string
    domain: string
    isMagazine?: boolean
    showComments?: boolean
    summaryData?: SummaryDataItem[]
    summaryUpdateType?: "disabled" | "auto" | "manual"
    articleId?: string
    readAloudUrl?: string | null
    readAloudDuration?: number | null
    mediaImageUrl?: string
    imagesDomain?: string
    isReadAloudPlayerHost?: boolean
}

interface ArticleMobileActionBarState {
    showComment: boolean
    wcmNumOfComments: string
    isReadAloudOpen: boolean
    isReadAloudPlaying: boolean
}

export class ArticleMobileActionBarComponent extends React.Component<ArticleMobileActionBarProps, ArticleMobileActionBarState>{
    public static siteScriptName = "ArticleMobileActionBarComponent";

    constructor(props) {
        super(props)
        this.state = {
            showComment: true,
            wcmNumOfComments: "",
            isReadAloudOpen: false,
            isReadAloudPlaying: false,
        }
    }

    private handleCommentsPopupVisability = () => {
        typeof window !== "undefined" && window.handleCommentsPopupVisability && window.handleCommentsPopupVisability();
    }

    componentDidMount() {
        document.addEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived);
        document.addEventListener(WCM_READ_ALOUD_STATE_EVENT, this.handleReadAloudState);
        if (this.isPlayerHostCandidate() && !activeMobileReadAloudPlayerHost && this.getResolvedReadAloud()) {
            activeMobileReadAloudPlayerHost = this
            document.addEventListener(WCM_READ_ALOUD_REQUEST_EVENT, this.handleReadAloudRequest);
        }
        const comments = document.getElementById("SiteArticleComments");
        const isBlogArticle = document.querySelector(".blog_article");

        if (!comments || isBlogArticle) {
            this.setState({
                showComment: false
            })
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener(WCM_COMMENTS_EVENT, this.handleOnWcmCommentsRecived);
        document.removeEventListener(WCM_READ_ALOUD_STATE_EVENT, this.handleReadAloudState);
        if (activeMobileReadAloudPlayerHost === this) {
            document.removeEventListener(WCM_READ_ALOUD_REQUEST_EVENT, this.handleReadAloudRequest);
            activeMobileReadAloudPlayerHost = null
        }
    }

    private isPlayerHostCandidate = () => {
        const { isReadAloudPlayerHost } = this.props
        if (typeof isReadAloudPlayerHost === "boolean") {
            return isReadAloudPlayerHost
        }
        return true
    }

    private isActivePlayerHost = () => {
        return activeMobileReadAloudPlayerHost === this
    }

    private handleOnWcmCommentsRecived = (e) => {
        this.setState({ wcmNumOfComments: e.detail.wcmNumOfComments });
    };

    private handleReadAloudState = (e: CustomEvent) => {
        const detail = e.detail as ReadAloudStateDetail
        if (!detail) {
            return
        }
        this.setState({
            isReadAloudOpen: detail.isOpen,
            isReadAloudPlaying: detail.isPlaying,
        })
    }

    private handleReadAloudRequest = (e: CustomEvent) => {
        const detail = e.detail as ReadAloudRequestDetail
        if (!detail || !this.isActivePlayerHost()) {
            return
        }
        if (detail.action === "open") {
            this.openReadAloudPlayer()
        } else if (detail.action === "toggle") {
            this.toggleReadAloudPlayback()
        }
    }

    private dispatchReadAloudState = (isOpen: boolean, isPlaying: boolean) => {
        if (typeof document === "undefined") {
            return
        }
        document.dispatchEvent(new CustomEvent(WCM_READ_ALOUD_STATE_EVENT, {
            detail: { isOpen, isPlaying } as ReadAloudStateDetail,
        }))
    }

    private getResolvedReadAloud = () => {
        const { readAloudUrl, readAloudDuration } = this.props
        return resolveReadAloudData(readAloudUrl, readAloudDuration)
    }

    private openReadAloudPlayer = () => {
        if (!this.getResolvedReadAloud()) {
            return
        }
        this.setState({ isReadAloudOpen: true, isReadAloudPlaying: true })
        this.dispatchReadAloudState(true, true)
    }

    private toggleReadAloudPlayback = () => {
        if (window.wcmAudioPlayer && typeof window.wcmAudioPlayer.togglePlayPause === "function") {
            window.wcmAudioPlayer.togglePlayPause()
            return
        }
        this.openReadAloudPlayer()
    }

    private handleReadAloudBtnClicked = () => {
        const { isReadAloudOpen } = this.state
        if (!this.getResolvedReadAloud()) {
            return
        }

        dispatchBepoRecommendationsOpen()

        if (!this.isActivePlayerHost()) {
            if (!activeMobileReadAloudPlayerHost) {
                activeMobileReadAloudPlayerHost = this
                document.addEventListener(WCM_READ_ALOUD_REQUEST_EVENT, this.handleReadAloudRequest)
                this.openReadAloudPlayer()
                return
            }
            document.dispatchEvent(new CustomEvent(WCM_READ_ALOUD_REQUEST_EVENT, {
                detail: { action: isReadAloudOpen ? "toggle" : "open" } as ReadAloudRequestDetail,
            }))
            return
        }

        if (!isReadAloudOpen) {
            this.openReadAloudPlayer()
            return
        }
        this.toggleReadAloudPlayback()
    }

    private handleReadAloudClose = () => {
        this.setState({ isReadAloudOpen: false, isReadAloudPlaying: false })
        this.dispatchReadAloudState(false, false)
    }

    private handleReadAloudPlayingChange = (isPlaying: boolean) => {
        this.setState({ isReadAloudPlaying: isPlaying })
        this.dispatchReadAloudState(true, isPlaying)
    }

    private handleWhatsAppClick = () => {
        const { url, title } = this.props;
        openWhatsAppShare(url, () => analyticsPushFunc("Whatsapp", "Article", title), "Article");
    };

    private renderReadAloudPlayer = () => {
        const { title, mediaImageUrl, domain, imagesDomain } = this.props
        const { isReadAloudOpen } = this.state
        const readAloud = this.getResolvedReadAloud()
        if (!this.isActivePlayerHost() || !isReadAloudOpen || !readAloud) {
            return null
        }

        const resolvedMediaImageUrl = resolveReadAloudMediaImageUrl(mediaImageUrl, imagesDomain)

        return (
            <BepoFloatingPlayerController
                title={title || ""}
                podcastName=""
                podcastImageUrl=""
                podcastPageUrl=""
                bepoHomeUrl={domain ? `${domain}/radio` : "/radio"}
                audioUrl={readAloud.url}
                mediaImageUrl={resolvedMediaImageUrl}
                duration={readAloud.durationSeconds || 0}
                isMobileWeb={true}
                footerVariant="sponsor"
                onClose={this.handleReadAloudClose}
                onPlayingChange={this.handleReadAloudPlayingChange}
            />
        )
    }

    render() {
        const {
            lang,
            summaryData,
            articleId,
            showComments,
            isMagazine,
        } = this.props;
        const { showComment, wcmNumOfComments, isReadAloudOpen, isReadAloudPlaying } = this.state;
        const langToUse = lang ? lang.slice(0, 2) : "he";
        const hasNoComments = !wcmNumOfComments || wcmNumOfComments === "0";
        const commentNumber = isMagazine
            ? formatCommentCountMagazine(wcmNumOfComments)
            : formatCommentCountRegular(wcmNumOfComments);
        const shouldRenderSummary = shouldRenderArticleSummary(summaryData, this.props.summaryUpdateType);
        const isPlaying = isReadAloudOpen && isReadAloudPlaying;
        const readAloud = this.getResolvedReadAloud();
        const audioText = readAloud ? formatReadAloudDuration(readAloud.durationSeconds, langToUse) : "";
        const summary = shouldRenderSummary && (
            <ArticleHeader1280AiSummary
                summaryData={summaryData}
                articleId={articleId}
                lang={isMagazine ? langToUse : (lang || "")}
                variant="mobile"
            />
        );

        let commentsLabel = "";
        if (!isMagazine) {
            const { commentsText, noCommentsText } = getActionBarLabels(lang);
            commentsLabel = hasNoComments ? noCommentsText : commentsText;
        }

        const audioBtn = readAloud && (
            <YplusPremiumGated>
                <button
                    className={`articleHeaderActionBarItem articleHeaderActionBarItemAudio${isPlaying ? " is-playing" : ""}`}
                    onClick={this.handleReadAloudBtnClicked}
                    type="button"
                    aria-label={isPlaying ? "השהה האזנה" : "האזנה לכתבה"}
                >
                    <span className="articleHeaderActionBarText">{audioText}</span>
                    <span className={`articleHeaderActionBarIcon articleHeaderActionBarIconAudio${isPlaying ? " articleHeaderActionBarIconAudio--playing" : ""}`} />
                </button>
            </YplusPremiumGated>
        );

        return (
            <div className={`articleHeaderActionBar ${isMagazine ? "articleHeaderActionBar--magazine" : "articleHeaderActionBarRegular"}`}>
                {isMagazine ? (
                    <>
                        <div className="articleHeaderActionBarIcons">
                            <button
                                className="articleHeaderActionBarIconBtn articleHeaderActionBarIconBtnWhatsapp"
                                onClick={this.handleWhatsAppClick}
                                type="button"
                                aria-label="WhatsApp"
                            />
                            {showComments && showComment && (
                                <button
                                    className="articleHeaderActionBarIconBtn articleHeaderActionBarIconBtnComments"
                                    onClick={this.handleCommentsPopupVisability}
                                    type="button"
                                    aria-label="תגובות"
                                >
                                    {!hasNoComments && commentNumber && (
                                        <span className="articleHeaderActionBarIconCommentCount">{commentNumber}</span>
                                    )}
                                </button>
                            )}
                        </div>
                        <div className="articleHeaderActionBarEnd">
                            {summary}
                            {audioBtn}
                        </div>
                    </>
                ) : (
                    <div className="articleHeaderActionBarInner">
                        {summary}
                        {audioBtn}
                        {showComments && showComment && (
                            <button className="articleHeaderActionBarItem articleHeaderActionBarItemComments" onClick={this.handleCommentsPopupVisability} type="button">
                                <span className="articleHeaderActionBarText">{commentsLabel}</span>
                                <span className={"articleHeaderActionBarIcon " + (hasNoComments ? "articleHeaderActionBarIconCommentsAdd" : "articleHeaderActionBarIconComments")}>
                                    {!hasNoComments && <span className="articleHeaderActionBarCommentCount">{commentNumber}</span>}
                                </span>
                            </button>
                        )}
                    </div>
                )}
                {this.renderReadAloudPlayer()}
            </div>
        );
    }
}
